import React from "react";

/**
 * Logo Nureal-Operation — sole + pannello fotovoltaico inclinato.
 * Inline SVG so it renders crisp at any size without external assets.
 */
export default function BrandLogo({ size = 32, withWordmark = false, wordmarkColor = "currentColor", className = "" }) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`} aria-label="Nureal-Operation">
      <svg width={size} height={size} viewBox="0 0 64 64" xmlns="http://www.w3.org/2000/svg" role="img" aria-hidden="true">
        <defs>
          <linearGradient id={`pgr-${size}`} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#1B5E20" />
            <stop offset="100%" stopColor="#0D3B14" />
          </linearGradient>
          <linearGradient id={`sgr-${size}`} x1="0" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#FFC107" />
            <stop offset="100%" stopColor="#FB8C00" />
          </linearGradient>
        </defs>
        {/* Sun rays */}
        <g stroke="#FFC107" strokeWidth="2.5" strokeLinecap="round" opacity="0.85">
          <line x1="44" y1="6" x2="44" y2="2" />
          <line x1="56" y1="14" x2="59.5" y2="11" />
          <line x1="60" y1="24" x2="63" y2="24" />
          <line x1="32" y1="14" x2="29" y2="11" />
        </g>
        <circle cx="44" cy="20" r="9" fill={`url(#sgr-${size})`} />
        <g transform="translate(4 26)">
          <path d="M 2 26 L 12 4 L 52 4 L 42 26 Z" fill={`url(#pgr-${size})`} stroke="#0A2D0E" strokeWidth="1.5" strokeLinejoin="round" />
          <g stroke="#43A047" strokeWidth="0.8" opacity="0.7" fill="none">
            <line x1="22" y1="4" x2="14.5" y2="26" />
            <line x1="32" y1="4" x2="25" y2="26" />
            <line x1="42" y1="4" x2="35.5" y2="26" />
            <line x1="9.5" y1="11.5" x2="49.5" y2="11.5" />
            <line x1="6.7" y1="18.5" x2="46.7" y2="18.5" />
          </g>
        </g>
        <rect x="28" y="55" width="8" height="6" fill="#1B5E20" rx="1" />
        <rect x="22" y="60" width="20" height="2" fill="#1B5E20" rx="1" />
      </svg>
      {withWordmark && (
        <span className="font-extrabold tracking-tight" style={{ fontFamily: "Manrope", color: wordmarkColor, fontSize: Math.max(size * 0.55, 14) }}>
          Nureal<span style={{ color: "#FB8C00" }}>·</span>Operation
        </span>
      )}
    </span>
  );
}
